import {populateTwoHeader} from '../PopulateComponents/populateTwoHeader';
import {populateBannerCarousel} from '../PopulateComponents/populateBannerCarousel';
import {populateAbout} from '../PopulateComponents/populateAbout';
import {populateMenu} from '../PopulateComponents/populateMenu';
import {populateLife} from '../PopulateComponents/populateLife';
import {populateTeam} from '../PopulateComponents/populateTeam';
import {populateVideoCarousel} from '../PopulateComponents/populateVideoCarousel';
import {populateTestimonialCarousel} from '../PopulateComponents/populateTestimonialCarousel';
import {populateBenefits} from '../PopulateComponents/populateBenefits';
import {populateFollow} from '../PopulateComponents/populateFollow';
import {populateFooter} from '../PopulateComponents/populateFooter';
import {populateJobs} from '../PopulateComponents/populateJobs';
import { populateMultipleShowcaseComponent } from '../PopulateComponents/populateMultipleShowcaseComponent';

if(window.location.href.indexOf(".html") == -1){
    companyId = window.location.host;
}
else{
    var pathname = window.location.pathname;
    var splitPathname = pathname.split("/");

    var splitCompanySpec = splitPathname[splitPathname.length - 1].split(".")[0].split("-");
    var companyId = splitCompanySpec[splitCompanySpec.length -1];
}

$(document).ready(function(){    
    if($(window).width() > 1440){
        $(".bannerTwo").css("padding", "50px 142px");
        $("section:not(.menu)").css("padding", "50px 142px");
        $("footer").css("padding", "50px 142px");
    }
});

$.ajax({
    type: 'GET',
    url: baseUrl + "companyPage/" + companyId,
    dataType: 'json',
    success: function(resData){
        console.log(resData);
        JSONDATAURL = resData.data.jsonFile;
        recruiterID = resData.data.createdBy;
        recruiterDomain = resData.data.domainName;
        managerIds = resData.data.managerId;
        hideJobId = resData.data.hideJobId;
        hideRecId = resData.data.hideRecId;
        hideManagerId = resData.data.hideManagerId;
        

        $.getJSON(JSONDATAURL, function(data){
            jsonData = data;      

            if(jsonData.life.included == undefined || jsonData.life.included == null){
                jsonData.life.included = true
            }
            if(jsonData.life.visibility == "required"){
                jsonData.life.visibility = "optional"
            }
                        
            populateTwoHeader(jsonData);   
            populateBannerCarousel(jsonData);         
            populateMenu(jsonData);
            populateAbout(jsonData);
            checkIncluded(jsonData.life.included, $(".life"), populateLife);
            checkIncluded(jsonData.videoCarousel.included, $(".video"), populateVideoCarousel);
            checkIncluded(jsonData.testimonialCarousel.included, $(".testimonial"), populateTestimonialCarousel);
            populateMultipleShowcaseComponent(jsonData);
            checkIncluded(jsonData.team.included, $(".team"), populateTeam);
            checkIncluded(jsonData.benefits.included, $(".perks"), populateBenefits);
            checkIncluded(jsonData.follow.included, $(".follow"), populateFollow);
            checkIncluded(jsonData.jobs.included, $(".jobs"), populateJobs);
            populateFooter(jsonData);
        });
    }
});

function checkIncluded(sectionIncluded, element, populateFunction){
    if(sectionIncluded === true){
        populateFunction(jsonData);        
    }
    else{
        if(!$(document).find(".preview").hasClass("hidden")){
            element.remove();        
        }
        else{
            populateFunction(jsonData);                            
            element.addClass("removeSection"); 
            element.prepend('<span class="optional-section-overlay"></span><div class="optional-section-include"><div class="button includeButton">Include This Section Again</div></div>');            
        }
    }
}